const getSelectOptions = (items = []) => {
  return items?.map((item) => ({
    label: item.title,
    value: item.id,
  })) || [];
};

export default getSelectOptions;
